<mat-form-field [class]="styleClass + ' remove-bottom-margin'">
  <input matInput [placeholder]="placeholder" [class]="'font-[Roboto]'" [formControl]="control">
  <mat-icon matPrefix>{{ icon }}</mat-icon>
</mat-form-field>
